var _circle, _g, _line, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 17,
    viewBox: "0 0 72 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_11813",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 1,
    width: 16,
    height: 16
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 9,
    r: 8,
    fill: "#42BE65"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_11813)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54,
    width: 10,
    height: 18,
    fill: "#A8A8A8"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 8.5,
    x2: 57,
    y2: 8.5,
    stroke: "#A8A8A8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C4.14214 16 7.5 12.6421 7.5 8.5C7.5 4.35786 4.14214 1 0 1",
    stroke: "#A8A8A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnection);
export default __webpack_public_path__ + "static/media/connection.95f2568fcbb7278fc6181e405907d4a2.svg";
export { ForwardRef as ReactComponent };